import React from 'react'
import ArticleV2Landing from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2Landing';
import ArticleV2SocialHeading from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2SocialHeading';
import ArticleV2Intro from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2Intro';
import ArticleV2ContentSection from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2ContentSection';
import ArticleV2BackgroundGradient from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2BackgroundGradient';
import ArticleV2DrawerContentSection from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2DrawerContentSection';
import ArticleV2SEO from '../components/__SeasonTwo__/__Pages__/ArticleV2/ArticleV2SEO';

const ArticleV2 = ({data}) => {

    data = data?.contentfulArticleV2
    
    if (!data) return <h2>No article data found</h2>


    return (
        <div>
            <ArticleV2SEO data={data}/>
            <ArticleV2Landing data={data}/>
            <ArticleV2SocialHeading data={data}/>
            <ArticleV2Intro data={data}/>
            <div className="article-body">
                <ArticleV2ContentSection data={data?.content} dropCapColor={data?.gradientColorsDropcap}/>
                <ArticleV2BackgroundGradient data={data}/>
            </div>

            <div className="drawer-content">
                <ArticleV2DrawerContentSection data={data?.drawerContent}/>
            </div>

            <style jsx>{`
                .article-body {
                    position: relative;
                    // padding-bottom: 60px;
                }

                .article-body :global(p) {
                    font-size: 22px;
                    line-height: 1.5;
                    font-weight: 400;
                }

                .article-body :global(h6) {
                    padding: 20px 0;
                    font-weight: 400;
                    line-height: 1.5;
                    font-size: 12px;
                }

                .article-body :global(h6 *) {
                  padding: 20px 0;
                  font-weight: 400;
                  line-height: 1.5;
                  font-size: 12px;
              }

                .article-body :global(h3) {
                    font-size: 36px;
                    font-weight: 900 !important;
                    line-height: 1.2;
                    font-style: italic;
                    font-family: 'elizeth';
                }


                .article-body :global(h3 *) {
                  font-size: 36px;
                  font-weight: 900 !important;;
                  line-height: 1.2;
                  font-style: italic;
                  font-family: 'elizeth';
              }

                

                @media (max-width: 769px), (pointer: coarse) {
                  .article-body :global(p) {
                    font-size: 19px;
                    line-height: 1.5;
                }
                }
            `}</style>
        </div>
    )
}


export default ArticleV2;

export const query = graphql`
  query($slug: String!) {
    contentfulArticleV2(slug: { eq: $slug }) {

      seo {
        title
        description
        image {
          file {
            url
          }
        }
      }
      
      title
      category
      publishDate(formatString: "MMMM Do, YYYY")

      author
      articleLength
      photography
      illustration
      gradientColors
      gradientColorsDropcap
      gradientColorsLandingOverlay
      posterImage {
        file {
            url
        }
      }

      introDescription {
        raw
      }

      content {
        ... on ContentfulTextBlock {
            id
            content {
              raw
            }
        }
        ... on ContentfulImage {
            id
            image {
                file {
                    url
                }
                description
            }
        }

        ... on ContentfulVideo {
            id
            videoType
            youtubeEmbedId
            content {
                file {
                    url
                }
            }
        }

        ...V2DrawerContent
      }

    }
  }
`